import { html } from 'lit-html';
import { LitElement, css } from 'lit-element';
import { CreateBreakerTypeBlock } from './breaker_type_block.js'
import { CreateAdditionalBlockCooldown } from './additional_block_cooldown.js'
import { CreateAdditionalBlockDuration } from './additional_block_duration.js'
import { CreateInsightSwitchBlockText } from "../insight_switch_block_text.js"
import { CreateInsightSwitchBlockManyStacks } from "./insight_switch_block_many_stacks.js"
import { CreateInsightSwitchBlockSliderTicks } from "./insight_switch_block_sliderticks.js"
import { CreateInsightSwitchBlockOnOff } from "./insight_switch_block_on_off.js"
import { imgPath } from "../math_functions.js"


var effect_type_to_name = {
    'aspect': 'Aspect',
    'fragment': 'Fragment',
    'grenade_ability': 'Grenade',
    'melee_ability': 'Melee',
    'class_ability': 'Class Ability',
    'buff': 'Effect',
    'debuff': 'Effect',
    'entity': 'Entity',
    "blue_armor_mod": 'Armor Mod',
    "green_armor_mod": 'Armor Mod',
    "white_armor_mod": 'Armor Mod',
    'armor_mod': 'Armor Mod',
    'exotic_weapon_intrinsic': 'Exotic Weapon Intrinsic',
    'exotic_armor_intrinsic': 'Exotic Armor Intrinsic',
    'activity': 'Activity',
    'super_ability': 'Super'
}

var breaker_types = {
    barrier: "barrier_champion_white.png",
    unstoppable: "unstoppable_champion_white.png",
    overload: "overload_champion_white.png"
}

export class InsightContainer extends LitElement {
    static properties = {
        effect_id: { type: String },
        switch_block: { type: Object },
        additional_block: { type: Object },
        effect_template_text: { type: String },
        effect_name: { type: String },
        switch_block: { type: Object },
        additional_block: { type: Object },
        breaker_type_block: { type: Object },
    };

    static styles = css`
        div.insight_container {
            background-color: var(--interface-main-color);
            border: 1px solid var(--interface-secondary-color);
            width: 100%;
            display: flex;
            flex-direction: column;
            margin: 5px auto;
        }

        div.insight_container_title {
            color: var(--interface-font-color);
            padding: 5px 5px 5px 5px;
            word-wrap: break-word;
            font-weight: bold;
        }

        div.effect_template {
            color: var(--interface-font-color);
            word-wrap: break-word;
            text-align: justify;
            text-justify: inter-word;
            margin: 5px 5px 5px 5px;
            padding: 5px 5px 5px 5px;
            /*white-space: pre-line;*/
            white-space: pre-wrap;
        }

        div.flex_row {
            display: flex;
            flex-direction: row;
        }

        div.summary_title_area
        {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            flex-grow: 1;
            padding-left: 5px;
        }

        hr.divider {
            margin: 0;
            background-color: var(--interface-secondary-color);
            height: 1px;
            border: none;
        }
        details.effect_insight_details {
            color: white;
            padding: 5px 5px 5px 5px;
            display: block;
        }

        details.effect_insight_details[open] summary {
          border-bottom: 1px solid var(--interface-secondary-color);
        }

        summary {
            display: flex;
            padding: 5px 5px 5px 5px;
            list-style: none;
            align-items: center;
        }

        summary::before {
          display: inline-block;
          content: '▼';
          float: left;
          transition: 0.2s;
          font-size: 1em;
          transform: rotate(-90deg);
        }

        details[open] > summary::before {
          transform: rotate(0deg);
        }

        div.insight_container_switch {
            display: flex;
            align-items: center;
            padding-left: 5px;
            margin: auto 0;
        }

        span.light
        {
            color: #99dada;
            font-weight: bold;
        }

        span.darkness
        {
            color: #ce522c;
            font-weight: bold;
        }


        span.kinetic
        {
            color: #a5a5a5;
            font-weight: bold;
        }

        span.solar
        {
            color: #ff9900;
            font-weight: bold;
        }

        span.solar_buff
        {
            color: #ffb300;
            font-weight: bold;
        }

        span.solar_debuff
        {
            color: #ff7700;
            font-weight: bold;
        }

        span.arc
        {
            color: #00a4ff;
            font-weight: bold;
        }

        span.arc_buff
        {
            color: #5eb8f5;
            font-weight: bold;
        }

        span.arc_debuff
        {
            color: #396a7e;
            font-weight: bold;
        }

        span.void
        {
            color: #b229ff;
            font-weight: bold;
        }

        span.void_buff
        {
            color: #d900ff;
            font-weight: bold;
        }

        span.void_debuff
        {
            color: #bca1dd;
            font-weight: bold;
        }

        span.stasis
        {
            color: #228AF2;
            font-weight: bold;
        }

        span.stasis_buff
        {
            color: #75C4FE;
            font-weight: bold;
        }

        span.stasis_debuff
        {
            color: #004FF8;
            font-weight: bold;
        }

        span.strand
        {
            color: #1a9543;
            font-weight: bold;
        }

        span.strand_buff
        {
            color: #1fae52;
            font-weight: bold;
        }

        span.strand_debuff
        {
            color: #157c34;
            font-weight: bold;
        }

        span.prismatic
        {
            color:  #ff40d0;
            font-weight: bold;
        }

        span.prismatic_buff
        {
            color: #ffaeeb;
            font-weight: bold;
        }

        span.prismatic_debuff
        {
            color: #d707a4;
            font-weight: bold;
        }

        span.melee
        {
            color: #00b3ff;
            font-weight: bold;
        }

        span.class
        {
            color: #c485e8;
            font-weight: bold;
        }

        span.grenade
        {
            color: #ff9900;
            font-weight: bold;
        }

        span.super
        {
            color: #fcfc03;
            font-weight: bold;
        }

        span.value
        {
            color: var(--value-color);
            font-weight: bold;
        }

        span.exotic
        {
            color: #fcfc03;
            font-weight: bold;
        }

        span.health
        {
            color: red;
            font-weight: bold;
        }

        span.special
        {
            color: #0ca40c;
            font-weight: bold;
        }

        span.heavy
        {
            color: #b229ff;
            font-weight: bold;
        }

        span.italic
        {
            font-style: italic;
        }

        span.bold
        {
            font-weight: bold;
        }

        span.crit
        {
            color: #fb4646;
        }

        span.enhanced
        {
            color: #fcfc03;
        }

        span.pvp
        {
            font-weight: bold;
            color: #d40e0e;
        }

        span.pve
        {
            font-weight: bold;
            color: #388ac5;
        }

        span.misc
        {
            color: #5baaff;
        }

        span.precision
        {
            color: #ff8f00;
        }

        img.inline_element_icon
        {
            display: inline-block;
            vertical-align: text-top;
            height: 1em;
        }

        span.pos
        {
            color: #12b712;
            font-size: 24px;
        }

        span.neg
        {
            color: red;
            font-size: 24px;
        }

    `;

    constructor(effect, sandbox) {
        super();

        if (effect.breaker_type != null)
        {
            this.breaker_type_block = CreateBreakerTypeBlock(imgPath(breaker_types[effect.breaker_type]));
        }
        else
        {
            this.breaker_type_block = null;
        }

        if (effect.type == 'buff' || effect.type == 'debuff')
        {
            if (effect.activation == 'auto')
                this.switch_block = CreateInsightSwitchBlockText("[Auto]");
            else if (effect.max_stack > 7)
                this.switch_block = CreateInsightSwitchBlockManyStacks(effect.id, effect.max_stack);
            else if (effect.max_stack > 1)
                this.switch_block = CreateInsightSwitchBlockSliderTicks(effect.id, effect.max_stack);
            else
                this.switch_block = CreateInsightSwitchBlockOnOff(effect.id);
        }
        else
        {
            if (effect.type == "perk")
            {
                this.switch_block = CreateInsightSwitchBlockText(`[${effect_type_to_name[effect.subtype]}]`);
            }
            else
            {
                this.switch_block = CreateInsightSwitchBlockText(`[${effect_type_to_name[effect.type]}]`);
            }
        }
        this.effect_name = effect.display_properties.name;

        this.effect_template_text = effect.get_template(sandbox);

        if ((effect.type == 'class_ability' || effect.type == 'melee_ability' || effect.type == 'grenade_ability' || effect.type == 'super_ability') && effect.cooldown != null)
            this.additional_block = CreateAdditionalBlockCooldown(effect.id, effect.type)
        else if (effect.active_duration == "timer" && effect.activation == "toggle" && effect.type == "buff" && effect.affect_cooldowns)
            this.additional_block = CreateAdditionalBlockDuration(effect.id);
        else
            this.additional_block = null;

    }

    updateDisplayCooldown(newVal)
    {
        if (this.additional_block != null)
        {
            this.additional_block.updateDisplayCooldown(newVal);
        }
    }

    updateDisplayDuration(newVal)
    {
        if (this.additional_block != null)
        {
            this.additional_block.setDuration(newVal);
        }
    }

    updateEffectTemplateText(newText)
    {
        this.effect_template_text = newText;
    }

    render() {
        return html`
            <div class="insight_container">
                <details open>
                    <summary>
                        <div class="summary_title_area">
                            <div class='flex_row'>
                                <div class="insight_container_title">
                                    ${this.effect_name}
                                </div>
                                ${this.breaker_type_block}
                            </div>
                            ${this.switch_block}
                        </div>
                    </summary>

                    <hr class="divider">

                    <div .innerHTML="${this.effect_template_text}"class="effect_template"></div>
                </details>
                ${this.additional_block}
            </div>
        `;
    }
}


customElements.define('insight-container', InsightContainer);

export function CreateInsightContainer(effect, sandbox)
{
    let InsightContainer_ = new InsightContainer(effect, sandbox);
    InsightContainer_.id = `insight_${effect.id}`;

    return InsightContainer_;
}


